import axiosInstance from './axiosInstance';

export const deviceApi = {
  getAll: (userId) =>
    axiosInstance.post('/device/get-all', {userId}),

  revokeOne: (userId, deviceId) =>
    axiosInstance.post('/device/revoke', { userId, deviceId }),

  revokeAll: (userId) =>
    axiosInstance.post('/device/remove-all', {userId}),
};
